declare namespace $ {

	export class $mol_icon_magnify_plus extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=plus.view.tree.d.ts.map